import { FileData } from "../context/GameContext";

export interface Email {
	_id: string; // MongoDb Id
	id: string;
	category: "inbox" | "sent" | "draft" | "deleted";
	sender: { email: string; name: string; avatarColor: string };
	receiver: { email: string; name: string; avatarColor: string };
	sentDate: Date;
	mailSubject: string;
	mailContent: string;
	isRead?: boolean;
	attachments?: FileData[];
}

export enum EmailNav {
	INBOX = "inbox",
	OUTBOX = "outbox",
	DRAFT = "draft",
	TRASH = "trash",
}
